const HTML_ENTITIES = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);

/**
 * Formats rich text coming from the backend translation fields into an array of
 * HTML-safe paragraph strings.
 *
 * The text is escaped in full *before* any markup is reintroduced, so the result
 * can only ever contain the tags generated below (<strong>). Anything else the
 * backend sends - <script>, onerror handlers, javascript: URLs - stays inert
 * text. Callers may therefore pass these strings to dangerouslySetInnerHTML.
 *
 * Supported authoring markup: <BR> for a line break and <b>...</b> for bold.
 */
const formatRichText = (rawText) => {
  if (typeof rawText !== "string") {
    return [];
  }

  return rawText
    .replace(/<BR\s*\/?>/gi, "\n")
    .split("\n")
    .filter((paragraph) => paragraph.trim() !== "")
    .map((paragraph) =>
      escapeHtml(paragraph).replace(
        /&lt;b&gt;([\s\S]*?)&lt;\/b&gt;/gi,
        "<strong>$1</strong>"
      )
    );
};

export { formatRichText };
